import React, { useRef } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getCategoryLabelById } from "../../../utils/labelsById";
import useExportChartImage from "../useExportChartImage";
import SaveButton from "../UI/SaveButton";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const COLOR_PALETTE = [
  "#6baed6", // blu
  "#e07b39", // portokalli
  "#bdbdbd", // gri
  "#f2c94c", // e verdhë
  "#4271c3", // blu e thellë
  "#9b59b6", // vjollcë
  "#84bd00", // jeshile
  "#ff7f0e", // portokalli e fortë
  "#2ca02c", // jeshile e errët
  "#d62728", // e kuqe
];
const generateColorMap = (dataChart) => {
  const entries = Object.keys(dataChart);
  const colorMap = {};

  entries.forEach((key, index) => {
    colorMap[key] = COLOR_PALETTE[index % COLOR_PALETTE.length];
  });

  return colorMap;
};

const PieChartVersion2 = ({ dataChart = {}, dataSetting, title }) => {
  const COLOR_MAP = generateColorMap(dataChart);
  const entries = Object.entries(dataChart);

  const chartRef = useRef();

  const exportChartImage = useExportChartImage();

  const fileName = dataSetting?.name + "_" + dataSetting?.year;

  const stateDataChart = entries.map(([name, value]) => ({
    name,
    value,
  }));

  const total = stateDataChart.reduce((sum, item) => sum + item.value, 0);

  const chartData = {
    labels: stateDataChart.map((item) => item.name),
    datasets: [
      {
        data: stateDataChart.map((item) =>
          ((item.value / total) * 100).toFixed(2)
        ),
        backgroundColor: stateDataChart.map(
          (item) => COLOR_MAP[item.name] || "#8884d8"
        ),
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    layout: {
      padding: 60,
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.formattedValue}%`,
        },
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value) => `${value}%`,
        anchor: "end",
        align: "end",
        offset: 4,
      },
    },
  };

  const handleExportImage = () => {
    exportChartImage({
      chartRef,
      fileName,
      dataSetting,
    });
  };

  return (
    <>
      <div ref={chartRef}>
        {title && (
          <h3 style={{ marginBottom: "20px" }}>
            {getCategoryLabelById(title)}
          </h3>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "60px",
          }}
        >
          {/* Legjenda në anën e majtë */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              alignItems: "flex-start",
            }}
          >
            {stateDataChart.map((item, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: COLOR_MAP[item.name] || "#8884d8",
                    borderRadius: "2px",
                  }}
                />
                <span style={{ fontSize: "14px", color: "#333" }}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>

          {/* Grafiku në të djathtë */}
          <div style={{ width: "400px" }}>
            <Pie data={chartData} options={options} />
          </div>
        </div>
      </div>
      <SaveButton onClick={handleExportImage} />
    </>
  );
};

export default PieChartVersion2;
